import { buildModelManager } from "../builder.js";
const DefaultStripeInvoiceSelection = {
  __typename: true,
  id: true,
  amountDue: true,
  amountPaid: true,
  createdAt: true,
  currency: true,
  dueDate: true,
  finalizedAt: true,
  hostedInvoiceUrl: true,
  invoiceCreatedAt: true,
  invoicePdf: true,
  livemode: true,
  number: true,
  paidAt: true,
  periodEnd: true,
  periodStart: true,
  profileId: true,
  status: true,
  stripeCustomerId: true,
  stripeId: true,
  stripeSubscriptionId: true,
  updatedAt: true,
  userId: true,
  voidedAt: true
};
const modelApiIdentifier = "stripeInvoice";
const pluralModelApiIdentifier = "stripeInvoices";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByStripeId",
    findByField: "stripeId",
    findByVariableName: "stripeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByStripeId",
    findByField: "stripeId",
    findByVariableName: "stripeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeInvoiceSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripeInvoiceGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripeInvoiceManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripeInvoiceSelection,
  operations
);
export {
  DefaultStripeInvoiceSelection,
  StripeInvoiceManager
};
//# sourceMappingURL=StripeInvoice.js.map
